import React, { useRef, useEffect } from "react";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

const LunaticBanner = () => {
  const lunaticBannerRef = useRef(null);
  const lunaticOverlayRef = useRef(null);
  const lunaticLogoRef = useRef(null);
  const lunaticTitleRef = useRef(null);
  const lunaticDescRef = useRef(null);
  const lunaticBtnRef = useRef(null);

  useEffect(() => {
    gsap.set(lunaticBannerRef.current, {
      opacity: 0,
      y: 100,
      scale: 0.95
    });
    gsap.set(lunaticOverlayRef.current, {
      opacity: 0,
      y: 50
    });
    gsap.set([lunaticLogoRef.current, lunaticTitleRef.current], {
      opacity: 0,
      y: 30,
      scale: 0.8
    });
    gsap.set(lunaticDescRef.current, {
      opacity: 0,
      y: 40
    });
    gsap.set(lunaticBtnRef.current, {
      opacity: 0,
      y: 20,
      scale: 0.7
    });
    if (lunaticBannerRef.current) {
      const lunaticTl = gsap.timeline({
        scrollTrigger: {
          trigger: lunaticBannerRef.current,
          start: "top 80%",
          end: "bottom 20%",
          toggleActions: "play none none reverse"
        }
      });
      lunaticTl.to(lunaticBannerRef.current, {
        opacity: 1,
        y: 0,
        scale: 1,
        duration: 1.5,
        ease: "power3.out"
      })
      .to(lunaticOverlayRef.current, {
        opacity: 1,
        y: 0,
        duration: 1,
        ease: "power2.out"
      }, "-=1.2")
      .to(lunaticLogoRef.current, {
        opacity: 1,
        y: 0,
        scale: 1,
        duration: 0.8,
        ease: "back.out(1.7)"
      }, "-=0.8")
      .to(lunaticTitleRef.current, {
        opacity: 1,
        y: 0,
        scale: 1,
        duration: 0.8,
        ease: "back.out(1.7)"
      }, "-=0.6")
      .to(lunaticDescRef.current, {
        opacity: 1,
        y: 0,
        duration: 1,
        ease: "power2.out"
      }, "-=0.4")
      .to(lunaticBtnRef.current, {
        opacity: 1,
        y: 0,
        scale: 1,
        duration: 0.6,
        ease: "back.out(1.7)"
      }, "-=0.6");
    }
    gsap.to(lunaticBannerRef.current, {
      yPercent: -15,
      ease: "none",
      scrollTrigger: {
        trigger: lunaticBannerRef.current,
        start: "top bottom",
        end: "bottom top",
        scrub: 1
      }
    });
    gsap.to(lunaticLogoRef.current, {
      y: -8,
      duration: 3,
      ease: "power2.inOut",
      yoyo: true,
      repeat: -1
    });
    if (lunaticDescRef.current) {
      const descText = lunaticDescRef.current.textContent || "";
      if (descText) {
        lunaticDescRef.current.innerHTML = "";
        const words = descText.split(' ');
        words.forEach((word, index) => {
          const span = document.createElement('span');
          span.textContent = word + ' ';
          span.style.opacity = '0';
          span.style.transform = 'translateY(20px)';
          span.style.display = 'inline-block';
          span.style.marginRight = '4px';
          lunaticDescRef.current.appendChild(span);
          gsap.to(span, {
            opacity: 1,
            y: 0,
            duration: 0.4,
            delay: 1.5 + (index * 0.05),
            ease: "power2.out",
            scrollTrigger: {
              trigger: lunaticDescRef.current,
              start: "top 80%",
              toggleActions: "play none none reverse"
            }
          });
        });
      }
    }
    gsap.to(lunaticBtnRef.current, {
      scale: 1.05,
      duration: 2,
      ease: "power2.inOut",
      yoyo: true,
      repeat: -1
    });
    return () => {
      ScrollTrigger.getAll().forEach(trigger => trigger.kill());
    };
  }, []);

  return (
    <div ref={lunaticBannerRef} className="lunatic-banner" style={{backgroundImage: "url('/12.jpg')"}}>
      <div ref={lunaticOverlayRef} className="lunatic-banner-overlay lunatic-banner-row">
        <div className="lunatic-banner-content-col">
          <div ref={lunaticLogoRef} className="lunatic-logo">If</div>
          <div ref={lunaticTitleRef} className="lunatic-title">Lunatic Fringe</div>
          <div ref={lunaticDescRef} className="lunatic-desc">A sanctuary of beauty and artistry, where only you matter. Here, every experience is personal—from the way we greet you at our door to how our skilled stylists and technicians listen intently to understand exactly what you want.</div>
        </div>
        <button ref={lunaticBtnRef} className="lunatic-btn">BOOK NOW</button>
      </div>
    </div>
  );
};

export default LunaticBanner; 